import React from "react";
// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Chat from "@material-ui/icons/Chat";
import Build from "@material-ui/icons/Build";
// core components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";

import UserData from './UserData.jsx'
import UserTrack from './UserTrack.jsx'


const styles = {
  textCenter: {
    textAlign: "center"
  },
  avatar: {
    width: '200px',
    height: '200px'
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
    marginBottom: "50px"
  }
};

class UserTabs extends React.Component{
  render(){
    const { classes } = this.props;
    const { profile } = this.props;
    return (
      <div>
        <CustomTabs
          plainTabs
          headerColor="info"
          tabs={[
            {
              tabName: "Profile",
              tabIcon: Face,
              tabContent: (
                    <UserData profile={profile} />
              )
            },
            {
              tabName: "Messages",
              tabIcon: Chat,
              tabContent: (
                    <UserTrack profile={profile} />
              )
            },
            {
              tabName: "Settings",
              tabIcon: Build,
              tabContent: (
                <p className={classes.textCenter}>
                  think that’s a responsibility that I have, to push
                  possibilities, to show people, this is the level that
                  things could be at. So when you get something that has
                  the name Kanye West on it, it’s supposed to be pushing
                  the furthest possibilities. I will be the leader of a
                  company that ends up being worth billions of dollars,
                  because I got the answers. I understand culture. I am
                  the nucleus.
                </p>
              )
            }
          ]}
        />
      </div>
    );
  }
}

export default withStyles(styles)(UserTabs);
